
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import './App.css';
import "react-datepicker/dist/react-datepicker.css";
import Login from './pages/Login';
import { Toaster } from "react-hot-toast";
import { AuthProvider } from './Component/context/AuthContext';
import DocumentUpload from './pages/documentUpload/DocumentUpload';
import MedicalNotes from './pages/medicalNote/medicalNote';
import PatientPortal from './pages/PatientPortal';
import { PatientDataProvider } from './commonFunction/storage/Patientdatacontext';
import MultiPatientPortal from './pages/MultiPatientPortal';


function ProtectedRoute() {
  const isAuthenticated = localStorage.getItem('userData');
  if (!isAuthenticated) {
    const tokenUrl = localStorage.getItem('tokenUrl');
    if (tokenUrl) {
      window.location.href = tokenUrl;
      return null;
    }
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

function App() {
  return (
    <>
      <Toaster position="top-right" />
        <PatientDataProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/"                   element={<Navigate to="/dashboard" replace />} />
              <Route path="/documents"          element={<DocumentUpload />} />
              <Route path="/medical-notes"      element={<MedicalNotes />} />
              <Route path="/patientPortal"      element={<PatientPortal />} />
              <Route path="/multiPatientPortal" element={<MultiPatientPortal />} />
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
        </PatientDataProvider>
    </>
  );
}

export default App;